import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Container, Typography } from "@material-ui/core";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

import { setCreativeApiError } from "../../actions/app/creatives";
import HTML5Stepper from "../../components/Steppers/HTML5Stepper";

// Google Analytics module
import ReactGA from "react-ga";

// initialize react-ga module
ReactGA.initialize("UA-172736709-1");
ReactGA.pageview("/html5");

const useStyles = makeStyles((theme) => ({
  route: {
    marginTop: theme.spacing(2),
    position: "relative",
    minHeight: "84vh"
  },
  link: {
    color: "#000",
    textDecoration: "none"
  },
  back: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  backIcon: {
    marginRight: 8
  },
  stepper: {
    paddingTop: "6vh"
  }
}));

const HTML5 = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCreativeApiError(new Error(), false));
  }, [dispatch]);

  return (
    <Container maxWidth="xl" className={classes.route}>
      <Link to="/" className={classes.link}>
        <div className={classes.back}>
          <ArrowBackIcon className={classes.backIcon} fontSize="small" />
          <Typography variant="body2">Return to placement selection</Typography>
        </div>
      </Link>
      <HTML5Stepper className={classes.stepper} />
    </Container>
  );
};

export default HTML5;
